
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"c-pic\">\n    <div class=\"linkbox\">\n        <span class=\"link\"></span>\n    </div>\n\n    <div class=\"infobox\">\n\n        <p class=\"title\">\n            <span class=\"column\">  ")
    ; __append(escape(options.channelName))
    ; __append("</span> | <span class=\"name\">")
    ; __append(escape(options.title))
    ; __append("</span>\n        </p>\n        <p class=\"info\">\n            <span class=\"state-flag\"></span>\n            ")
    ;  if(isLive == '0'){ 
    ; __append("\n\n            <span class=\"status prefield\"> <span class=\"pcolor\"></span>预告</span>\n            ")
    ;  }else if(isLive == '1'){ 
    ; __append("\n\n            <span class=\"status active\"> <span class=\"acolor\"></span>直播中</span>\n            ")
    ;  }else{ 
    ; __append("\n            <span class=\"ecolor\"></span>\n            <span class=\"status end\"> <span class=\"acolor\"></span>回放</span>\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if (showOnlineNum) { 
    ; __append("\n                <span class=\"count\"><em class=\"number\">0</em>人参与</span>\n            ")
    ;  } 
    ; __append("\n        </p>\n    </div>\n</div>\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/modules/onlypic/onlypic.ejs
// module id = 513
// module chunks = 0